import { AssertionDescriptorDetail } from '../assertiondescriptor/AssertionDescriptorDetail';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParams } from 'react-router-dom';

function AssertionDescriptorDetailWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();
    
    return <AssertionDescriptorDetail guid={guid || ''} user={user} />;
}

export default AssertionDescriptorDetailWrapper;
